import { useEffect } from 'react';
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, } from 'root/src/client/v2/common/components/ui/command';
import { useRedesignCommandPalette } from 'root/src/client/v2/layout/features/RedesignCommandPalette/redesignCommandPalette.context';
import { useRedesignNavItems } from 'root/src/client/v2/layout/features/RedesignCommandPalette/useRedesignNavItems';
const Kbd = ({ children }) => (<kbd className="inline-flex h-4 min-w-[16px] items-center justify-center rounded border border-solid border-white/[0.1] bg-white/[0.04] px-1 font-mono text-[10px] leading-none text-muted-foreground">
		{children}
	</kbd>);
// The command palette dialog: Cmd/Ctrl+K toggles it, cmdk handles fuzzy search + arrow/Enter, and
// each item navigates or runs an account action. Mounted once by RedesignCommandPaletteProvider.
export const RedesignCommandPalette = () => {
    const { open, setOpen, closePalette, toggle } = useRedesignCommandPalette();
    const groups = useRedesignNavItems();
    useEffect(() => {
        const handler = (event) => {
            if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
                event.preventDefault();
                toggle();
            }
        };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [toggle]);
    const runItem = (onSelect) => {
        closePalette();
        onSelect();
    };
    return (<CommandDialog open={open} onOpenChange={setOpen}>
			<CommandInput placeholder="Search pages and actions..."/>
			<CommandList>
				<CommandEmpty>No results found.</CommandEmpty>
				{groups.map(group => (<CommandGroup key={group.heading} heading={group.heading}>
						{group.items.map((item) => {
                const { Icon } = item;
                return (<CommandItem key={item.id} value={item.label} keywords={item.keywords} onSelect={() => runItem(item.onSelect)}>
									<Icon sx={{ fontSize: 18 }} className="shrink-0 text-muted-foreground"/>
									{item.label}
								</CommandItem>);
            })}
					</CommandGroup>))}
			</CommandList>
			<div className="flex items-center gap-3 border-t border-solid border-border px-3.5 py-2.5 text-[11px] text-muted-foreground">
				<span className="flex items-center gap-1"><Kbd>↑</Kbd><Kbd>↓</Kbd> navigate</span>
				<span className="flex items-center gap-1"><Kbd>↵</Kbd> select</span>
				<span className="flex items-center gap-1"><Kbd>esc</Kbd> close</span>
			</div>
		</CommandDialog>);
};
